import React from 'react';

/**
 * Temporary Mingo egg icon component.
 * Replace this SVG only when final character is ready.
 */
function MingoEgg({ hatching = false, open = false }) {
  return (
    <span
      className={`mingo-egg${hatching ? ' mingo-egg--hatching' : ''}${open ? ' mingo-egg--open' : ''}`}
      aria-hidden="true"
    >
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="mingoEggShell" x1="17" y1="3" x2="17" y2="31" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#FFD79A" />
            <stop offset="1" stopColor="#FF9F43" />
          </linearGradient>
        </defs>
        <ellipse cx="17" cy="18" rx="11.5" ry="13.5" fill="url(#mingoEggShell)" stroke="#F97316" strokeWidth="1.5" />
        <ellipse cx="17" cy="12.2" rx="6.8" ry="2.7" fill="rgba(255,255,255,0.38)" />
        <circle cx="13.6" cy="17.6" r="1.35" fill="#7C2D12" />
        <circle cx="20.4" cy="17.6" r="1.35" fill="#7C2D12" />
        <path d="M14 21.5C14.9 22.4 16 22.9 17 22.9C18 22.9 19.1 22.4 20 21.5" stroke="#7C2D12" strokeWidth="1.35" strokeLinecap="round" />
      </svg>
    </span>
  );
}

export default MingoEgg;
